import { Component, HostBinding, inject, Input, type OnInit } from '@angular/core';
import { ChatCoreToggleButtonComponent, ChatService, ViewMode, type Config } from '@big-direkt/chat-core';
import { IconBigMediumChat } from '@big-direkt/utils/icons';
import { type BehaviorSubject } from 'rxjs';

@Component({
    selector: 'big-chat-toggle',
    templateUrl: './chat-toggle.component.html',
    standalone: false,
})
export class ChatToggleComponent extends ChatCoreToggleButtonComponent implements OnInit {
    public readonly iconChat = IconBigMediumChat;

    private readonly chatService = inject(ChatService);

    @HostBinding('class') public classList = 'print:hidden';

    @Input() public override activeViewMode!: ViewMode;
    @Input() public override viewMode: ViewMode = ViewMode.chooseChat;

    public config!: BehaviorSubject<Config>;

    public override ngOnInit(): void {
        super.ngOnInit();

        this.config = this.chatService.getConfig();
    }

    public toggleVisibility(): void {
        this.chatService.toggleVisibility();
    }

    public setViewMode(viewMode: ViewMode): void {
        const config: Config = this.chatService.currentConfig();

        if (config.panel.viewMode === this.viewMode && config.panel.visible !== undefined) {
            this.chatService.setVisibility(false);
            this.chatService.setViewMode(0);

            return;
        }

        this.chatService.setVisibility(true);
        this.chatService.setViewMode(viewMode);
    }
}
